module.exports = __webpack_public_path__ + "static/media/poof.9a662286.mp3";